import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
// import Table from '@material-ui/core/Table';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
// import GochiMenuTableHead from '../../components/molecules/GochiMenuTableHead';
// import GochiMenuTableBody from '../../components/molecules/GochiMenuTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
// import ExPagination from '../../components/molecules/ExPagination';
import GochiMenuDetailShop from './GochiMenuDetailShop';
import GochiMenuEditShop from './GochiMenuEditShop';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import DetailTextButton from '../../components/atoms/DetailTextButton';
import EditTextButton from '../../components/atoms/EditTextButton';
import DeleteTextButton from '../../components/atoms/DeleteTextButton';
// import ShowHideTextButton from '../../components/atoms/ShowHideTextButton';
import ShowHideSwitchButton from '../../components/atoms/ShowHideSwitchButton';
import CoppyButton from '../../components/atoms/CoppyButton';
import {
  getGochiMenus,
  getGochiMenuDetail,
  deleteGochiMenu,
  showHideGochiMenu,
  ignoreGochiMenu,
  changeShashokuOption,
  getMenuImageSample,
  GET_MENU_IMAGE_SUCCESS
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import NotifyPopupShop from '../../components/molecules/NotifyPopupShop';
import listMenuChildTypes from '../../constants/MenuChildType';
import enabledStripeBilling from '../../constants/StripeBilling';
import ChangeShashokuOptionButton from '../../components/atoms/ChangeShashokuOptionButton';
import GochiMenuDetailShopV2 from './GochiMenuDetailShopV2';
import GochiMenuEditShopV2 from './GochiMenuEditShopV2';
import usageTypes from '../../constants/UsageType';

const styles = {
  scrollTable: {
    maxHeight: 375,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  lstMenu: {
    padding: 0
  },
  menuItem: {
    padding: 10,
    borderTop: '1px solid #DBDBDB'
  },
  menuCard: {
    boxShadow: 'none',
    width: '100%',
    borderRadius: 0
  },
  menuCnt: {
    padding: 0,
    display: 'flex',
    marginBottom: 12
  },
  menuImg: {
    width: 80,
    boxShadow:
      '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
  },
  menuInfo: {
    paddingLeft: 12,
    width: 'calc(100% - 80px)'
  },
  menuName: {
    fontSize: 16,
    color: '#000000',
    marginBottom: 5,
    whiteSpace: 'normal',
    fontWeight: 'bold',
    wordBreak: 'break-all'
  },
  menuPriceCombo: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.54)',
    whiteSpace: 'normal',
    wordBreak: 'break-all'
  },
  menuGroupName: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'rgba(0,0,0,0.54)',
    borderRadius: 2,
    border: '1px solid #DBDBDB',
    padding: '2px 5px'
  },
  menuPrice: {
    fontSize: 14
  },
  cardActions: {
    backgroundColor: '#F7F7F7',
    justifyContent: 'center',
    padding: '5px 10px'
  },
  marginRight10: {
    display: 'inline-block',
    marginRight: 10
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  opacity04: {
    opacity: 0.4
  },
  opacityTemp: {
    opacity: '0.4 !important'
  },
  notOpacityTemp: {
    opacity: '1 !important'
  },
  menuTypeTag: {
    display: 'inline-block',
    fontSize: 10,
    fontWeight: 'bold',
    padding: '3px 10px',
    borderRadius: 4,
    backgroundColor: '#FFFBD0',
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: 5,
    marginRight: 5
  },
  subscriptionTag: {
    display: 'inline-block',
    fontSize: 10,
    fontWeight: 'bold',
    marginLeft: '5px',
    padding: '3px 10px',
    borderRadius: 4,
    backgroundColor: '#f12d2d',
    color: '#ffffff',
    marginBottom: 5
  },
  boxImg: {
    position: 'relative'
  },
  divMultiUsedMenu: {
    position: 'absolute',
    left: -20,
    top: -12,
    backgroundColor: '#71C9C1',
    width: 62,
    height: 33,
    transform: 'rotate(-34deg)',
    zIndex: 9
  },
  labelMultiUsedMenu: {
    position: 'absolute',
    fontSize: 9,
    fontWeight: 'bold',
    color: '#ffffff',
    left: 0,
    top: 8,
    transform: 'rotate(-34deg)',
    zIndex: 10
  },
  labelMultiUsedMenuQuantity: {
    position: 'relative',
    fontSize: 10,
    backgroundColor: '#EC4956',
    color: '#FFFB93',
    bottom: 6,
    right: -19,
    width: 57,
    textAlign: 'center',
    borderRadius: 20
  },
  expiration: {
    color: 'red'
  },
  expirationEndDate: {
    fontSize: 10,
    marginRight: 5
  },
  displaySetting: {
    display: 'flex'
  },
  changeShashokuOptionButton: {
    width: 160,
    fontSize: 10,
    padding: 0,
    marginLeft: 10,
    marginBottom: 10
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getGochiMenuDetail,
          deleteGochiMenu,
          showHideGochiMenu,
          ignoreGochiMenu,
          changeShashokuOption,
          getMenuImageSample
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDetailNewModal', 'updateOpenDetailNewModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditNew', 'updateOpenEditNew', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('deleteNote', 'setDeleteNote', ''),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 0),
  withState('comboMenu', 'setComboMenu', 0),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('price', 'setPrice', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('expiration', 'setExpiration', ''),
  withState('description', 'setDescription', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('taxTypeStr', 'setTaxTypeStr', '外税'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('reducedTaxTypeStr', 'setReducedTaxTypeStr', '対象外'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('subscription', 'setSubscription', ''),
  withState('subscriptionInterval', 'setSubscriptionInterval', ''),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('isIgnore', 'setIgnore', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('openShowHide', 'updateOpenShowHide', false),
  withState('showHideNote', 'setShowHideNote', ''),
  withState('showHide', 'setShowHide', 1),
  withState('openNotifyPopup', 'setOpenNotifyPopup', false),
  withState('textMessage', 'setTextMessage', ''),
  withState('tempShowHide', 'setTempShowHide', []),
  withState('tempShashokuOption', 'setTempShashokuOption', []),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuSituationNames', 'setMenuSituationNames', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuUserTargetNames', 'setMenuUserTargetNames', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('usageType', 'setUsageType', 0),
  withState('menuImageSampleList', 'setMenuImageSampleList', []),
  withState('shopGochiRestriction', 'setShopGochiRestriction', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    account,
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    // page,
    // selectedPage,
    handleChangePage,
    // menus,
    // totalCount,
    listMenus,
    name,
    openDetailModal,
    updateOpenDetailModal,
    openDetailNewModal,
    updateOpenDetailNewModal,
    openDelete,
    updateOpenDelete,
    deleteNote,
    setDeleteNote,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    isIgnore,
    setIgnore,
    otherLanguages,
    setOtherLanguages,
    openEdit,
    updateOpenEdit,
    openEditNew,
    updateOpenEditNew,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    menuChildType,
    setMenuChildType,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    shopId,
    setShopId,
    shopName,
    setShopName,
    menuId,
    setMenuId,
    menuName,
    setMenuName,
    comboMenu,
    setComboMenu,
    price,
    setPrice,
    priceCombo,
    setPriceCombo,
    quantityRelease,
    setQuantityRelease,
    quantityPromotion,
    setQuantityPromotion,
    usageLimit,
    setUsageLimit,
    description,
    setDescription,
    promotionDescription,
    setPromotionDescription,
    expiration,
    setExpiration,
    expirationEndDate,
    setExpirationEndDate,
    taxType,
    setTaxType,
    taxTypeStr,
    setTaxTypeStr,
    reducedTaxType,
    setReducedTaxType,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxTypeStr,
    setReducedTaxTypeStr,
    setSubscription,
    setSubscriptionInterval,
    setSubscriptionIntervalCount,
    subscription,
    subscriptionInterval,
    subscriptionIntervalCount,
    tags,
    setTags,
    tagStr,
    setTagStr,
    image,
    setImage,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    // order,
    // orderBy,
    // handleRequestSort,
    openShowHide,
    updateOpenShowHide,
    showHideNote,
    setShowHideNote,
    showHide,
    setShowHide,
    textMessage,
    setTextMessage,
    openNotifyPopup,
    setOpenNotifyPopup,
    tempShowHide,
    setTempShowHide,
    tempShashokuOption,
    setTempShashokuOption,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuSituationIds,
    setmenuSituationIds,
    menuSituationNames,
    setMenuSituationNames,
    menuUserTargetIds,
    setmenuUserTargetIds,
    menuUserTargetNames,
    setMenuUserTargetNames,
    menuLimitTotal,
    setMenuLimitTotal,
    isFukuoka,
    usageType,
    setUsageType,
    menuImageSampleList,
    setMenuImageSampleList,
    shopGochiRestriction,
    setShopGochiRestriction
  }) => {
    // const emptyRows =
    //   rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const USAGE_TYPE_MENU = usageTypes[0].id;

    const paramShowHide = {
      showHide
    };

    const paramIgnore = () => ({
      shopId: account.shopId,
      ignore: showHide ? 0 : 1
    });
    const detail = {
      menuChildType,
      groupId,
      groupName,
      shopId,
      shopName,
      menuId,
      menuName,
      price,
      description,
      comboMenu,
      priceCombo,
      subscriptionIntervalCount,
      subscriptionInterval,
      subscription,
      quantityRelease,
      quantityPromotion,
      promotionDescription,
      usageLimit,
      expiration,
      expirationEndDate,
      taxType,
      taxTypeStr,
      reducedTaxType,
      reducedTaxCheck,
      reducedTaxTypeStr,
      tags,
      tagStr,
      image,
      createdAt,
      updatedAt,
      otherLanguages,
      menuGenreName,
      menuSituationNames,
      menuUserTargetNames,
      menuGenreId,
      menuSituationIds,
      menuUserTargetIds,
      menuLimitTotal,
      usageType
    };

    useEffect(() => {
      setTempShowHide([]);
    }, [listMenus]);

    const getGochiMenu = async (id, isEdit) => {
      await actions.getGochiMenuDetail(id).then(async detailData => {
        checkSession(detailData);
        setMenuChildType(detailData.payload.menuChildType);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setMenuId(detailData.payload.menuId);
        setMenuName(detailData.payload.menuName);
        setPrice(detailData.payload.price);
        setDescription(detailData.payload.description);
        setTaxType(detailData.payload.taxType);
        setTaxTypeStr(detailData.payload.taxTypeStr);
        setReducedTaxType(detailData.payload.reducedTaxType);
        setOtherLanguages(detailData.payload.otherLanguages);
        setSubscription(detailData.payload.subscription);
        setSubscriptionInterval(detailData.payload.subscriptionInterval);
        setSubscriptionIntervalCount(
          detailData.payload.subscriptionIntervalCount
        );
        setMenuLimitTotal(detailData.payload.menuLimitTotal);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          setReducedTaxCheck(true);
          if (isFukuoka) {
            setReducedTaxTypeStr('対象');
          } else {
            setReducedTaxTypeStr('対象内');
          }
        } else {
          setReducedTaxCheck(false);
          setReducedTaxTypeStr('対象外');
        }
        setTags(detailData.payload.tags);
        setTagStr(
          detailData.payload.tags
            .map(tag => {
              return `${tag.tagName}`;
            })
            .join(' ')
        );
        setComboMenu(detailData.payload.menuCombo);
        setPriceCombo(detailData.payload.priceCombo);
        setQuantityRelease(detailData.payload.quantity);
        setQuantityPromotion(detailData.payload.quantityFree);
        setPromotionDescription(detailData.payload.quantityFreeDes);
        setUsageLimit(detailData.payload.numberUsePerDay);
        setExpiration(detailData.payload.expiration);
        setExpirationEndDate(detailData.payload.expirationEndDate);
        setImage(detailData.payload.image);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        if (detailData.payload.menuGenreId) {
          setMenuGenreId(detailData.payload.menuGenreId);
          setMenuGenreName(
            menuGenre.find(
              genre =>
                genre.menuGenreId.toString() ===
                detailData.payload.menuGenreId.toString()
            ).menuGenreName
          );
        } else {
          setMenuGenreId(null);
          setMenuGenreName('');
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const userTargetNames = [];
          detailData.payload.menuUserTargetIds.forEach(userTargetId => {
            const userTargetname = menuUserTarget.find(
              userTarget =>
                userTarget.menuUserTargetId.toString() ===
                userTargetId.toString()
            ).name;
            userTargetNames.push(userTargetname);
          });
          setmenuUserTargetIds(detailData.payload.menuUserTargetIds);
          setMenuUserTargetNames(userTargetNames.join(', '));
        } else {
          setmenuUserTargetIds([]);
          setMenuUserTargetNames('');
        }
        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const situationNames = [];
          detailData.payload.menuSituationIds.forEach(situationId => {
            const situationName = menuSituation.find(
              situation =>
                situation.menuSituationId.toString() === situationId.toString()
            ).menuSituationName;
            situationNames.push(situationName);
          });
          setmenuSituationIds(detailData.payload.menuSituationIds);
          setMenuSituationNames(situationNames.join(', '));
        } else {
          setmenuSituationIds([]);
          setMenuSituationNames('');
        }
        if (!isFukuoka) {
          setUsageType(detailData.payload.usageType);
          setShopGochiRestriction(detailData.payload.gochiRestriction);
          if (isEdit && detailData.payload.usageType === USAGE_TYPE_MENU) {
            const response = await actions.getMenuImageSample();
            if (response.type === GET_MENU_IMAGE_SUCCESS) {
              setMenuImageSampleList(response.payload);
            } else {
              setMenuImageSampleList([]);
            }
          }
        }
      });
    };
    const detailOpenAction = async params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      await getGochiMenu(params.id, false)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (isFukuoka) {
            updateOpenDetailModal(true);
          } else {
            updateOpenDetailNewModal(true);
          }
        })
        .catch(error => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          console.log(error);
        });
    };
    const editOpenAction = (id, readOnly) => {
      if (readOnly === true) {
        setTextMessage(
          'このメニューは未使用の「ごち」が残っているため、変更できません。'
        );
        setOpenNotifyPopup(true);
      } else {
        progress.updateLoading(true);
        progress.updateOpenProgress(true);
        getGochiMenu(id, true)
          .then(() => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            if (isFukuoka) {
              updateOpenEdit(true);
            } else {
              updateOpenEditNew(true);
            }
          })
          .catch(() => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      }
    };
    const deleteOpenAction = (id, readOnly) => {
      if (readOnly === true) {
        setTextMessage(
          'このメニューは未使用の「ごち」が残っているため、削除できません。メニューとして表示したくない場合は「非表示」を選択ください。'
        );
        setOpenNotifyPopup(true);
      } else {
        let note = '';
        listMenus
          .filter(item => item.menuId === id)
          .forEach(menu => {
            if (menu.gochiKidFlag === 1) {
              note = '※当メニューは、こどもごちめし利用対象メニューです。';
            }
          });
        updateOpenDelete(true);
        setTargetRowId(id);
        setDeleteNote(note);
      }
    };
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedMenu = await actions
        .deleteGochiMenu(targetRowId)
        .then(data => checkSession(data));
      if (deletedMenu.type === 'DELETE_GOCHI_MENU_SUCCESS') {
        updateIsDeleteSuccess(true);
        handleChangePage(null, 1, rowsPerPage);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage(
          'メニューが購入されているため、削除できません。非表示設定をすると新規の購入ができなくなります。'
        );
        updateLoading(false);
      }
    };

    const showHideOpenAction = params => {
      updateOpenShowHide(true);
      if (params.showHide) {
        setShowHide(0);
      } else {
        setShowHide(1);
      }
      setTargetRowId(params.id);
      setIgnore(params.isIgnore);
      const arr = [];
      if (params.gochimeshiFlag === 1) {
        arr.push('「ごちめし（さきめし含む）」');
      }
      if (params.shashokuFlag === 1) {
        arr.push('「社食ごちめし」');
      }
      if (params.gochiKidFlag === 1) {
        arr.push('「こどもごちめし」');
      }
      if (arr.length) {
        setShowHideNote(`※${arr.join('と')}で、メニューが非公開になります。`);
      } else {
        setShowHideNote('');
      }
    };
    const cancelShowHideAction = () => updateOpenShowHide(false);
    const lstTemp = tempShowHide;
    const showHideAction = async () => {
      updateLoading(true);
      const showHidedMenu = isIgnore
        ? await actions
            .ignoreGochiMenu(targetRowId, paramIgnore())
            .then(data => checkSession(data))
        : await actions
            .showHideGochiMenu(targetRowId, paramShowHide)
            .then(data => checkSession(data));
      if (
        showHidedMenu.type === 'SHOW_HIDE_GOCHI_MENU_SUCCESS' ||
        showHidedMenu.type === 'IGNORE_GOCHI_MENU_SUCCESS'
      ) {
        // handleChangePage(null, 1, 10);
        const found = lstTemp.some(el => el.targetMenuId === targetRowId);
        if (!found) {
          lstTemp.push({
            showHide: paramShowHide.showHide,
            targetMenuId: targetRowId
          });
        } else {
          const objIndex = lstTemp.findIndex(
            obj => obj.targetMenuId === targetRowId
          );
          lstTemp[objIndex].showHide = paramShowHide.showHide;
        }
        // lstTemp.push({
        //   showHide: paramShowHide.showHide,
        //   targetMenuId: targetRowId
        // });
        setTempShowHide(lstTemp);
        updateLoading(false);
        updateOpenShowHide(false);
      } else {
        updateLoading(false);
        updateOpenShowHide(false);
      }
    };

    const lstShashokuTemp = tempShashokuOption;

    const changeShashokuOptionAction = async params => {
      updateLoading(true);
      const shashokuOn = params.shashokuFlag;
      const gochimeshiOn = params.gochimeshiFlag;
      const changeResponse = await actions
        .changeShashokuOption(params.menuId, shashokuOn, gochimeshiOn)
        .then(data => checkSession(data));
      if (changeResponse.type === 'CHANGE_SHASHOKU_OPTION_SUCCESS') {
        const found = lstShashokuTemp.some(
          el => el.targetMenuId === params.menuId
        );
        if (!found) {
          lstShashokuTemp.push({
            gochimeshiFlag: params.gochimeshiFlag,
            shashokuFlag: params.shashokuFlag,
            targetMenuId: params.menuId
          });
        } else {
          const objIndex = lstShashokuTemp.findIndex(
            obj => obj.targetMenuId === params.menuId
          );
          lstShashokuTemp[objIndex].gochimeshiFlag = params.gochimeshiFlag;
          lstShashokuTemp[objIndex].shashokuFlag = params.shashokuFlag;
        }
        setTempShashokuOption(lstShashokuTemp);
        updateLoading(false);
      } else {
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    const index = 1;

    return (
      <div>
        {listMenus && (
          <List dense={false} className={classes.lstMenu}>
            {listMenus.map(gochiMenu => {
              const isMultiUsedMenu =
                gochiMenu.menuChildType === 3 ||
                gochiMenu.menuChildType === 4 ||
                gochiMenu.menuChildType === 5;

              const params = {
                id: gochiMenu.menuId,
                showHide: isMultiUsedMenu
                  ? !gochiMenu.ignore
                  : gochiMenu.showHide,
                gochimeshiFlag: gochiMenu.gochimeshiFlag,
                shashokuFlag: gochiMenu.shashokuFlag,
                gochiKidFlag: gochiMenu.gochiKidFlag,
                isIgnore:
                  gochiMenu.menuChildType === 3 ||
                  gochiMenu.menuChildType === 4 ||
                  gochiMenu.menuChildType === 5
              };

              const key = `${gochiMenu.menuId}-${gochiMenu.shopId}-${
                gochiMenu.groupName
              }`;

              const expirationDate = gochiMenu.expirationEndDate
                ? new Date(gochiMenu.expirationEndDate)
                : null;

              let temOpacity = null;
              let tempShowHideVal = null;

              if (tempShowHide.length > 0) {
                const objIndex = tempShowHide.findIndex(
                  obj => obj.targetMenuId === gochiMenu.menuId
                );
                if (tempShowHide[objIndex]) {
                  if (
                    tempShowHide[objIndex].targetMenuId === gochiMenu.menuId
                  ) {
                    params.showHide = tempShowHide[objIndex].showHide;
                    tempShowHideVal = tempShowHide[objIndex].showHide;
                    temOpacity =
                      tempShowHide[objIndex].showHide === 0
                        ? classes.opacityTemp
                        : classes.notOpacityTemp;
                  }
                }
              }

              if (tempShashokuOption.length > 0) {
                const objIndex = tempShashokuOption.findIndex(
                  obj => obj.targetMenuId === gochiMenu.menuId
                );
                if (tempShashokuOption[objIndex]) {
                  if (
                    tempShashokuOption[objIndex].targetMenuId ===
                    gochiMenu.menuId
                  ) {
                    params.gochimeshiFlag =
                      tempShashokuOption[objIndex].gochimeshiFlag;
                    params.shashokuFlag =
                      tempShashokuOption[objIndex].shashokuFlag;
                  }
                }
              }

              let showHideButton;
              if (tempShowHideVal !== null) {
                showHideButton = tempShowHideVal;
              } else {
                showHideButton =
                  (!isMultiUsedMenu && gochiMenu.showHide === 1) ||
                  (isMultiUsedMenu && !gochiMenu.ignore)
                    ? 1
                    : 0;
              }

              const titleStatusArr = [];
              if (params.gochimeshiFlag === 1) {
                titleStatusArr.push('ごちめし（さきめし含む）');
              }
              if (params.shashokuFlag === 1) {
                titleStatusArr.push('社食ごちめし');
              }
              if (params.gochiKidFlag === 1) {
                titleStatusArr.push('こどもごちめし');
              }
              const titleStatus = titleStatusArr.join(', ');

              return (
                <ListItem
                  className={classes.menuItem}
                  key={key}
                  tabIndex={index + 1}
                >
                  <Card className={classes.menuCard}>
                    <CardContent className={classes.menuCnt}>
                      <Box className={classes.boxImg}>
                        <CardMedia
                          component="img"
                          alt={gochiMenu.menuName}
                          width="80"
                          image={
                            gochiMenu.image ||
                            (isFukuoka
                              ? 'images/logo_fukuoka_no_image.png'
                              : 'images/logo.png')
                          }
                          title={gochiMenu.menuName}
                          className={[
                            classes.menuImg,
                            !showHideButton && classes.opacity04,
                            temOpacity
                          ]}
                        />
                        {gochiMenu.menuCombo === 1 && (
                          <>
                            <div className={classes.divMultiUsedMenu} />
                            <span className={classes.labelMultiUsedMenu}>
                              回数券
                            </span>
                          </>
                        )}
                        {gochiMenu.menuCombo === 1 &&
                          gochiMenu.quantityFree > 0 && (
                            <div className={classes.labelMultiUsedMenuQuantity}>
                              {`+`}
                              {gochiMenu.quantityFree}
                              枚無料
                            </div>
                          )}
                      </Box>
                      <Box className={classes.menuInfo}>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="h5"
                          className={[
                            classes.menuName,
                            !showHideButton && classes.opacity04,
                            temOpacity
                          ]}
                        >
                          {gochiMenu.menuName}
                        </Typography>
                        {gochiMenu.menuCombo === 1 && (
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="h5"
                            className={[
                              classes.menuPriceCombo,
                              !showHideButton && classes.opacity04,
                              temOpacity
                            ]}
                          >
                            {`[${gochiMenu.priceCombo}円ｘ${
                              gochiMenu.quantity
                            }枚]`}
                          </Typography>
                        )}

                        {gochiMenu.expiration && (
                          <>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[
                                classes.expirationEndDate,
                                !showHideButton && classes.opacity04,
                                temOpacity
                              ]}
                            >
                              利用期限
                            </Typography>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[
                                classes.expiration,
                                classes.expirationEndDate,
                                !showHideButton && classes.opacity04,
                                temOpacity
                              ]}
                            >
                              {`${gochiMenu.expiration}日間`}
                            </Typography>
                          </>
                        )}

                        {expirationDate && (
                          <>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[
                                classes.expirationEndDate,
                                !showHideButton && classes.opacity04,
                                temOpacity
                              ]}
                            >
                              利用期間
                            </Typography>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[
                                classes.expirationEndDate,
                                classes.expiration,
                                !showHideButton && classes.opacity04,
                                temOpacity
                              ]}
                            >
                              {`${expirationDate.getMonth() +
                                1}月${expirationDate.getDate()}日まで`}
                            </Typography>
                          </>
                        )}

                        {isMultiUsedMenu && (
                          <Typography
                            gutterBottom
                            component="p"
                            className={[
                              classes.menuGroupName,
                              !showHideButton && classes.opacity04,
                              temOpacity
                            ]}
                          >
                            {gochiMenu.groupName}
                            {' (グループ)'}
                          </Typography>
                        )}
                        <Typography
                          gutterBottom
                          component="p"
                          className={[
                            classes.menuPrice,
                            !showHideButton && classes.opacity04,
                            temOpacity
                          ]}
                        >
                          {gochiMenu.price}
                          {'円'}
                        </Typography>
                        <span className={classes.menuTypeTag}>
                          {listMenuChildTypes.map(item => {
                            if (
                              parseInt(gochiMenu.menuChildType, 10) === item.id
                            ) {
                              let itemName = item.name;
                              if (isFukuoka) {
                                if (item.id === 1) {
                                  itemName = '通常（教室別）';
                                } else if (item.id === 4 || item.id === 5) {
                                  itemName = 'グループ共通';
                                }
                              }
                              return itemName;
                            }
                            return '';
                          })}
                        </span>
                        {gochiMenu.menuLimitTotal === 1 && !isFukuoka && (
                          <span className={classes.menuTypeTag}>
                            一円単位利用
                          </span>
                        )}
                        {gochiMenu.subscription === 1 &&
                          enabledStripeBilling === true && (
                            <span className={classes.subscriptionTag}>
                              サブスク
                            </span>
                          )}
                        <Typography
                          gutterBottom
                          component="p"
                          className={classes.menuPrice}
                        >
                          <b>{isFukuoka ? '表示' : 'メニュー表示'}</b>
                        </Typography>

                        <div className={classes.displaySetting}>
                          <ShowHideSwitchButton
                            params={params}
                            onClickAction={showHideOpenAction}
                            showHide={showHideButton}
                            className={classes.paddingTop7}
                            disabled={
                              gochiMenu.menuEventId &&
                              (gochiMenu.showHide === 0 ||
                                showHideButton === 0) &&
                              (roles.isShop || roles.isGroup)
                            }
                          />

                          {gochiMenu.shashokuOption && !isFukuoka && (
                            <ChangeShashokuOptionButton
                              className={classes.changeShashokuOption}
                              buttonClassName={
                                classes.changeShashokuOptionButton
                              }
                              disabled={!gochiMenu.shashokuOption}
                              titleStatus={titleStatus}
                              params={params}
                              onClickAction={changeShashokuOptionAction}
                            />
                          )}
                        </div>

                        {!isFukuoka && (
                          <Typography
                            gutterBottom
                            component="p"
                            className={classes.menuPrice}
                          >
                            <b className={classes.marginRight10}>ごちボタン</b>
                            <CoppyButton
                              linkToCopy={`https://web.app-gochimeshi.com/?id=${
                                gochiMenu.menuId
                              }`}
                            />
                          </Typography>
                        )}
                      </Box>
                    </CardContent>

                    <CardActions className={classes.cardActions}>
                      <DetailTextButton
                        params={params}
                        onClickAction={detailOpenAction}
                      />
                      {gochiMenu.menuType !== 'DEFAULT' &&
                        gochiMenu.menuType !== 'AKISHIMA' &&
                        gochiMenu.menuType !== 'EVENT' &&
                        gochiMenu.menuCombo !== 1 &&
                        gochiMenu.subscription !== 1 &&
                        !isMultiUsedMenu &&
                        ((gochiMenu.menuChildType !== 2 &&
                          gochiMenu.menuChildType !== 3) ||
                          isFukuoka) && (
                          <EditTextButton
                            id={gochiMenu.menuId}
                            readOnly={gochiMenu.readonly}
                            onClickAction={editOpenAction}
                          />
                        )}
                      {!isMultiUsedMenu && (
                        <DeleteTextButton
                          id={gochiMenu.menuId}
                          readOnly={gochiMenu.readonly}
                          onClickAction={deleteOpenAction}
                        />
                      )}
                    </CardActions>
                  </Card>
                </ListItem>
              );
            })}
          </List>
        )}

        <div>
          <Modal open={openNotifyPopup}>
            <NotifyPopupShop
              setOpenNotifyPopup={setOpenNotifyPopup}
              textMessage={textMessage}
            />
          </Modal>
        </div>

        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modalMobile}
        >
          <GochiMenuDetailShop
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
            isFukuoka={isFukuoka}
          />
        </Modal>

        <Modal
          open={openDetailNewModal}
          onClose={() => {
            updateOpenDetailNewModal(false);
          }}
          className={classes.modalMobile}
        >
          <GochiMenuDetailShopV2
            updateOpenDetailModal={updateOpenDetailNewModal}
            detail={detail}
            menuGenre={menuGenre}
          />
        </Modal>

        <Modal open={openEdit} className={classes.modalMobile}>
          <GochiMenuEditShop
            name={name}
            roles={roles}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEdit}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
            handleChangePage={handleChangePage}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
            isFukuoka={isFukuoka}
          />
        </Modal>

        <Modal open={openEditNew} className={classes.modalMobile}>
          <GochiMenuEditShopV2
            name={name}
            roles={roles}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEditNew}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
            handleChangePage={handleChangePage}
            menuGenre={menuGenre}
            menuImageSampleList={menuImageSampleList}
            shopGochiRestriction={shopGochiRestriction}
          />
        </Modal>

        <ConfirmDialog
          openConfirm={openShowHide}
          cancelAction={cancelShowHideAction}
          updateOpenConfirm={updateOpenShowHide}
          okAction={showHideAction}
          targetRowId={targetRowId}
          message="表示状況を変更します。よろしいでしょうか？"
          note={showHideNote}
          isSmall
        />
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target={isFukuoka ? 'コース' : 'メニュー'}
          deleteNote={deleteNote}
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
